// TAS-126: single source of truth for step-type → in-game route.
//
// This map was duplicated in GameWrapper (the GM's local navigation) and
// useGameEvents (followers' broadcast-driven navigation), and the two drifted:
//   - 'game-rules' 404'd for followers (routed to a nonexistent /game/game-rules)
//     while the GM silently skipped it;
//   - 'prize' navigated the GM but returned null for followers, so they never
//     followed the room to the prize screen;
//   - 'group-review' dropped the &wines= list for followers.
// Both consumers now derive the path here. Each keeps its OWN handling of a
// null return: the GM auto-advances a pass-through step, followers simply wait
// for the next real navigation.
//
// Returns the route string, or null for pass-through / unknown step types that
// have no dedicated screen — 'game-rules' and the legacy 'ability' steps are
// pass-throughs the GM advances past (there is no rules/ability route).
export function stepTypeToRoute(step, { sessionCode, gameType, hideWineDetails, wineList } = {}) {
  if (!step || !sessionCode) return null;
  const { type, wine, index, category } = step;
  const wines = Array.isArray(wineList) ? wineList.join(',') : '';

  switch (type) {
    case 'intro':
      return `/game/intro?code=${sessionCode}${category ? `&category=${category}` : ''}${wine ? `&wine=${wine}` : ''}&gameType=${gameType}`;
    case 'wine-intro':
      return `/game/intro?code=${sessionCode}&wine=${wine}&hideDetails=${hideWineDetails}`;
    case 'question':
      return `/game?code=${sessionCode}&wine=${wine}`;
    case 'reveal':
    case 'reveal-answer':
      return `/game/reveal?code=${sessionCode}&wine=${wine}&question=${index}`;
    case 'discussion':
      return `/game/discussion?code=${sessionCode}&wine=${wine}&question=${index}`;
    case 'results':
      return `/game/results?code=${sessionCode}&wine=${wine}&question=${index}`;
    case 'scoreboard':
      return `/game/scoreboard?code=${sessionCode}${wine ? `&wine=${wine}` : ''}`;
    case 'participation-mode':
      return `/game/participation-mode?code=${sessionCode}`;
    case 'game-view-mode':
      return `/game/game-view-mode?code=${sessionCode}`;
    case 'final-leaderboard':
      return `/game/final-leaderboard?code=${sessionCode}`;
    case 'wine-review':
      return `/game/review?code=${sessionCode}&wine=${wine}&hideDetails=${hideWineDetails}`;
    case 'wine-rating-reveal':
      return `/game/wine-rating-reveal?code=${sessionCode}&wine=${wine}`;
    case 'wine-reveal':
      return `/game/wine-reveal?code=${sessionCode}&wine=${wine}`;
    case 'group-review':
      return `/game/group-review?code=${sessionCode}${wine ? `&wine=${wine}` : ''}&wines=${wines}`;
    case 'prize':
      return `/game/prize?code=${sessionCode}`;
    case 'thank-you':
      return `/game/thank-you?code=${sessionCode}`;
    default:
      // Pass-through (game-rules, legacy ability) or unknown — no screen.
      return null;
  }
}
